import {UserLevel} from '@netx/core-user-next/constants';

export const SYSTEM_VIEW_MINIMUM_USER_LEVEL = UserLevel.DIRECTOR;

export const SYSTEM_LOGINS_MINIMUM_USER_LEVEL = UserLevel.ADMIN;
